<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-sm-8 col-lg-6 col-xl-5">
            <div class="box__cont">

                <!-- QR + OTP input: shown before backup codes -->
                <ng-container *ngIf="backupCodes.length === 0">
                    <div class="box__title box__title--otp">
                        <h1>Set Up Authenticator</h1>
                        <h2>Scan the QR code below with your authenticator app (e.g. Google Authenticator, Authy) to set up two-factor authentication.</h2>
                        <h3 class="box__error-notif" *ngIf="isNotValidInputs">The input fields are incomplete.</h3>
                    </div>
                    <div class="box__form">
                        <div *ngIf="isLoading" class="col-12 box__field text-center">
                            <p>Loading...</p>
                        </div>
                        <div *ngIf="!isLoading" class="col-12 box__field text-center">
                            <qrcode [qrdata]="qrCodeUri" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
                        </div>
                        <div *ngIf="!isLoading" class="col-12 box__field text-center">
                            <p>Can't scan? Enter this key manually:</p>
                            <p><strong>{{ manualSecret }}</strong></p>
                        </div>
                        <div [class.error]="isError" class="col-12 box__field box__field--otp" (keydown)="onOtpKeydown($event)">
                            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)"
                                          [config]="{length: 6,
                                                    allowNumbersOnly: true,
                                                    inputClass: 'red',
                                                    containerClass: 'f-form_input'}">
                            </ng-otp-input>
                        </div>
                        <div *ngIf="isInvalidCode" class="col-12 box__field box__field--otp text-center">
                            <h3 class="box__error-notif">Invalid code. Please try again.</h3>
                        </div>
                        <div class="row justify-content-center">
                            <div class="d-sm-none col-12">
                                <div class="buttons">
                                    <div class="row">
                                        <div class="col-12">
                                            <atram-button label="Confirm"
                                                componentClass="btn-submit"
                                                (on-click)="proceed()">
                                            </atram-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-none d-sm-block col-12 offset-sm-6 col-sm-6">
                                <div class="buttons">
                                    <div class="row">
                                        <div class="col-12">
                                            <atram-button label="Confirm"
                                                componentClass="btn-submit"
                                                (on-click)="proceed()">
                                            </atram-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Backup codes: shown after successful confirmation -->
                <ng-container *ngIf="backupCodes.length > 0">
                    <div class="box__title box__title--otp">
                        <h1>Save Your Backup Codes</h1>
                        <h2>Each code can be used once if you lose access to your authenticator app. Store them in a secure offline location.</h2>
                    </div>
                    <div class="box__form">
                        <div class="col-12 box__field">
                            <div *ngFor="let code of backupCodes" class="text-center" style="font-family: monospace; font-size: 1.1rem; letter-spacing: 0.15em; padding: 4px 0;">
                                {{ code }}
                            </div>
                        </div>
                        <div class="col-12 box__field text-center">
                            <p class="resend-otp" style="cursor: pointer;" (click)="copyBackupCodes()">Copy to Clipboard</p>
                            <p *ngIf="copyFeedback" style="font-size: 0.85rem; color: #5b6573;">{{ copyFeedback }}</p>
                        </div>
                        <div class="row justify-content-center">
                            <div class="d-sm-none col-12">
                                <div class="buttons">
                                    <div class="row">
                                        <div class="col-12">
                                            <atram-button label="Continue to Sign In"
                                                componentClass="btn-submit"
                                                (on-click)="continueToSignIn()">
                                            </atram-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-none d-sm-block col-12 offset-sm-4 col-sm-8">
                                <div class="buttons">
                                    <div class="row">
                                        <div class="col-12">
                                            <atram-button label="Continue to Sign In"
                                                componentClass="btn-submit"
                                                (on-click)="continueToSignIn()">
                                            </atram-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
